import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-300' : 'text-dark-500';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="relative">
        <div className="w-11 h-11 rounded-md bg-dark-900 border-2 border-athletic-500 flex items-center justify-center transform group-hover:-rotate-3 transition-transform shadow-button">
          <span className="font-display font-bold text-athletic-500 text-lg tracking-tighter leading-none">SP</span>
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-bold text-xl tracking-wide uppercase ${textColor} transition-colors`}>
          Sound <span className="text-athletic-500">Peak</span>
        </span>
        <span className={`text-[10px] font-semibold uppercase tracking-[0.3em] mt-0.5 ${subTextColor} transition-colors`}>
          Gear &middot; Musical Instruments
        </span>
      </div>
    </Link>
  );
};

export default Logo;
